/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs */

const en_svc_ecommerce_amazon_tools_execute_detail7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings, sync and monitors live, one channel at a time.`)
};

const ar_svc_ecommerce_amazon_tools_execute_detail7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القوائم والمزامنة والمراقبة مُطلَقة، قناة واحدة في كل مرة.`)
};

const bn_svc_ecommerce_amazon_tools_execute_detail7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লিস্টিং, সিঙ্ক আর মনিটর লাইভ, একবারে এক চ্যানেল।`)
};

const de_svc_ecommerce_amazon_tools_execute_detail7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings, Sync und Monitore live, ein Kanal nach dem anderen.`)
};

const es_svc_ecommerce_amazon_tools_execute_detail7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuncios, sincronización y monitores en vivo, un canal a la vez.`)
};

const fr_svc_ecommerce_amazon_tools_execute_detail7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annonces, synchronisation et moniteurs en ligne, un canal à la fois.`)
};

const pt_svc_ecommerce_amazon_tools_execute_detail7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anúncios, sincronização e monitores no ar, um canal de cada vez.`)
};

const zh_svc_ecommerce_amazon_tools_execute_detail7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing、同步和监控逐个渠道上线。`)
};

const tr_svc_ecommerce_amazon_tools_execute_detail7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listelemeler, senkron ve monitörler canlı, her seferinde bir kanal.`)
};

const ru_svc_ecommerce_amazon_tools_execute_detail7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Листинги, синк и мониторы вживую, по одному каналу за раз.`)
};

const pl_svc_ecommerce_amazon_tools_execute_detail7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listingi, sync i monitoring na żywo, po jednym kanale naraz.`)
};

/**
* | output |
* | --- |
* | "Listings, sync and monitors live, one channel at a time." |
*
* @param {Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_execute_detail7 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Execute_Detail7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_execute_detail7(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_execute_detail7(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_execute_detail7(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_execute_detail7(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_execute_detail7(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_execute_detail7(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_execute_detail7(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_execute_detail7(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_execute_detail7(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_execute_detail7(inputs)
	return en_svc_ecommerce_amazon_tools_execute_detail7(inputs)
});
export { svc_ecommerce_amazon_tools_execute_detail7 as "svc_ecommerce-amazon-tools_EXECUTE_detail" }